import { FC, memo, useContext } from "react";
import { iViewBoxProps } from "./LineChart.helpers";
import { LineChartThemeContext } from "./LineChartTheme.context";

export interface iAxisYPoint {
    title: string;
    y: number;
}

const LineChartAxisY: FC<{
    data: iAxisYPoint[],
    viewport: iViewBoxProps;
}> = (
    {
        data,
        viewport,
    }
) => {
    const { THEME } = useContext(LineChartThemeContext);
    return (
        <g
            name="axis-y"
            className="LineChart__axis"
            style={{
                transform: `translateX(-${viewport.padding.left * 0.15}px)`,
            }}
        >
            {data.map((point, index) => (
                <text
                    key={`${point.y}-${index}`}
                    x={0}
                    y={point.y}
                    fill={THEME.TEXT.DEFAULT}
                    textAnchor="end"
                    alignmentBaseline="middle"
                >
                    {point.title}
                </text>
            ))}
        </g>
    );
}

export default memo(LineChartAxisY);